import { render } from "./ServiceModel.vue?vue&type=template&id=b07182a4&scoped=true"
import script from "./ServiceModel.vue?vue&type=script&lang=js"
export * from "./ServiceModel.vue?vue&type=script&lang=js"

import "./ServiceModel.vue?vue&type=style&index=0&id=b07182a4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b07182a4"]])

export default __exports__